
EmptyPartLocationsController.$inject = ['EmptyPartLocationsDataSource', '$state', 'slotTrakPartsServer']
function EmptyPartLocationsController(EmptyPartLocationsDataSource, $state, slotTrakPartsServer) {
  var vm = this
  vm.$onInit = $onInit
  vm.deleteLocation = deleteLocation

  function $onInit() {
    vm.gridOptions = {
      columnDefs: [
        { headerName: 'Part Number', field: 'PartNumber', editable: false },
        { headerName: 'Manufacturer', field: 'PartManufacturerName', editable: false },
        { headerName: 'Shelf', field: 'Shelf', editable: false },
        { headerName: 'Bin', field: 'Bin', editable: false },
        { headerName: 'Quantity', field: 'Quantity', editable: false },
        { headerName: 'Cabinet', field: 'Cabinet', editable: false },
        { headerName: 'Description', field: 'PartDescription', editable: false },
        { headerName: 'Property Name', field: 'PartPropertyName', editable: false },
        { headerName: 'Keyword', field: 'PartKeywordName', editable: false },
        { headerName: 'Status', field: 'Status', editable: false },
        {
          headerName: '',
          width: 100,
          template: '<button class="btn btn-danger" ng-click="ctrl.deleteLocation(data)"><i class="fa fa-trash-o"></i></button>',
          suppressSorting: true,
          suppressMenu: true
        }
      ],
      rowHeight: 40,
      rowSelection: 'single',
      angularCompileRows: true,
      enableServerSideSorting: true,
      enableServerSideFilter: true,
      ready: gridReady
    }
  }

  function gridReady() {
    const query = { Quantity: 0 }
    vm.gridOptions.api.setDatasource(new EmptyPartLocationsDataSource(query, vm.gridOptions))
  }

  function deleteLocation(rowData) {
    if (confirm('Are you sure you want to delete this location?')) {
      slotTrakPartsServer.deletePartLocation(rowData.PartLocationId)
        .then(() => {
          gridReady()
        })
       
    }
  }
  
  
}

export default EmptyPartLocationsController
